"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Personalisation = void 0;
var _mui = require("@ori-ui/mui");
var _globalApiClientReact = require("@ori/global-api-client-react");
var _TranslationKey = require("../models/TranslationKey");
var _useConsultantNameFormatters = require("../utils/useConsultantNameFormatters");
var _FormattedMessage = require("./FormattedMessage");
var _jsxRuntime = require("react/jsx-runtime");
const Container = (0, _mui.styled)('div')(({
  theme
}) => ({
  display: 'grid',
  boxSizing: 'border-box',
  gridTemplateColumns: '1fr',
  gridTemplateRows: `auto minmax(${theme.spacing(2)}, auto)`,
  width: '100%',
  borderBottom: `2px solid ${theme.palette.grey[100]}`,
  '& link': {
    display: 'block',
    padding: theme.spacing(2, 3, 2, 3)
  }
}));
const Info = (0, _mui.styled)('div')(({
  theme
}) => ({
  alignSelf: 'center',
  padding: theme.spacing(2, 3, 2, 3),
  color: theme.palette.grey[900],
  fontSize: '12px',
  fontWeight: 'bold'
}));
const Name = (0, _mui.styled)('span')(({
  theme
}) => ({
  display: 'block',
  overflow: 'hidden',
  fontSize: '18px',
  textOverflow: 'ellipsis',
  whiteSpace: 'nowrap'
}));
const Action = (0, _mui.styled)('div')(({
  theme
}) => ({
  padding: theme.spacing(0, 3, 3)
}));
const Button = (0, _mui.styled)('a')(({
  theme
}) => ({
  display: 'block',
  boxSizing: 'border-box',
  width: '100%',
  height: theme.spacing(6),
  paddingTop: theme.spacing(1),
  borderRadius: theme.spacing(1),
  background: theme.palette.grey[100],
  color: theme.palette.grey[700],
  fontSize: '14px',
  fontWeight: 'bold',
  textAlign: 'center'
}));
const Personalisation = ({
  user,
  upgradeToConsultantUrl,
  upgradeToBrandPartnerUrl
}) => {
  const {
    getFormattedConsultantName
  } = (0, _useConsultantNameFormatters.useConsultantNameFormatters)();
  if (user.userType === _globalApiClientReact.GlobalApplicationsPersonalMenuPersonalMenuDtoUserType.Employee) {
    return null;
  }
  let upgradeToConsultant = null;
  if (user.userType === _globalApiClientReact.GlobalApplicationsPersonalMenuPersonalMenuDtoUserType.EndCustomer && upgradeToConsultantUrl) {
    upgradeToConsultant = /*#__PURE__*/(0, _jsxRuntime.jsx)(Action, {
      children: /*#__PURE__*/(0, _jsxRuntime.jsx)(Button, {
        href: upgradeToConsultantUrl,
        children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_FormattedMessage.FormattedMessage, {
          id: _TranslationKey.TranslationKey.UpgradeToConsultant
        })
      })
    });
  }
  let upgradeToBrandPartner = null;
  if (user.userType === _globalApiClientReact.GlobalApplicationsPersonalMenuPersonalMenuDtoUserType.EndCustomer && upgradeToBrandPartnerUrl) {
    upgradeToBrandPartner = /*#__PURE__*/(0, _jsxRuntime.jsx)(Action, {
      children: /*#__PURE__*/(0, _jsxRuntime.jsx)(Button, {
        href: upgradeToBrandPartnerUrl,
        children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_FormattedMessage.FormattedMessage, {
          id: _TranslationKey.TranslationKey.UpgradeToBrandPartner
        })
      })
    });
  }
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)(Container, {
    children: [/*#__PURE__*/(0, _jsxRuntime.jsxs)(Info, {
      children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_FormattedMessage.FormattedMessage, {
        id: _TranslationKey.TranslationKey.Hello
      }), ",", /*#__PURE__*/(0, _jsxRuntime.jsx)("br", {}), /*#__PURE__*/(0, _jsxRuntime.jsx)(Name, {
        children: getFormattedConsultantName(user.firstName, user.lastName)
      })]
    }), upgradeToConsultant, upgradeToBrandPartner]
  });
};
exports.Personalisation = Personalisation;